module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.field.values), function(option, index) {
    return _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isValueHidden(option.label)),
        expression: "!isValueHidden(option.label)"
      }],
      staticClass: "mt-checkbox mt-checkbox-outline"
    }, [_vm._v("\n    " + _vm._s(option.label) + "\n    "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: _vm.required && !_vm.field.hide && _vm.value.length === 0
        }),
        expression: "{required: required && !field.hide && value.length === 0}"
      }],
      attrs: {
        "name": _vm.field.name + '-' + index,
        "type": "checkbox",
        "id": option.name,
        "disabled": _vm.locked,
        "data-vv-as": _vm.field.description.replace(/\./g, ''),
        "data-vv-name": _vm.field.name
      },
      domProps: {
        "value": option.label,
        "checked": _vm.value.includes(option.label)
      },
      on: {
        "change": function($event) {
          return _vm.toggleValue(option.label)
        }
      }
    }), _vm._v(" "), _c('span')])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4be45b80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/CheckboxGroupRender.vue
// module id = 1637
// module chunks = 1